import { useEffect, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoneyBill,
  faCalendarWeek,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../Auths/CheckUser";
import { Link } from "react-router-dom";

const SewaArrears = () => {
  const { user } = useAuth();
  const [totalArrears, setTotalArrears] = useState(0);
  const [weeklyArrears, setWeeklyArrears] = useState(0);
  const [monthlyArrears, setMonthlyArrears] = useState(0);

  useEffect(() => {
    if (!user?.id) return;

    const fetchStaffClients = async () => {
      try {
        const res = await axios.get(`https://globizsystems.click/api/user/${user.id}`);
        const staffData = res.data;
        const clientList = Array.isArray(staffData.clients) ? staffData.clients : [];

        calculateArrears(clientList);
      } catch (err) {
        console.error("Error fetching staff clients:", err);
      }
    };

    fetchStaffClients();
  }, [user]);

  const calculateArrears = (records) => {
    const now = new Date();
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay());
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    let total = 0;
    let weekly = 0;
    let monthly = 0;

    records.forEach((item) => {
      if (!item.createdAt) return;
      const date = new Date(item.createdAt);
      const arrears = item.arrears || 0;

      if (item.status === "AKTIF" || item.status === "Active") {
        total += arrears;
        if (date >= startOfWeek && date <= endOfWeek) weekly += arrears;
        if (date >= startOfMonth && date <= endOfMonth) monthly += arrears;
      }
    });

    setTotalArrears(total);
    setWeeklyArrears(weekly);
    setMonthlyArrears(monthly);
  };

  return (
    <div className=" min-h-screen">
      {/* Page Title */}
      <div className="text-center mb-5">
        <h3 className="text-xl font-bold text-gray-800">Laporan Sewa</h3>
        <p className="text-gray-500 text-sm">Staff: {user?.name}</p>
      </div>

      {/* Total Arrears */}
      <div className="bg-gradient-to-r from-red-500 to-rose-600 p-4 rounded-xl shadow-md mb-6 text-white hover:scale-[1.01] transition-transform duration-300">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-sm font-medium">Jumlah Tunggakan Sewa </h3>
            <p className="text-2xl font-bold mt-1">RM {totalArrears.toFixed(2)}</p>
          </div>
          <div className="bg-white/20 p-3 rounded-full">
            <FontAwesomeIcon icon={faMoneyBill} className="text-white text-xl" />
          </div>
        </div>
      </div>

      {/* Weekly Report */}
      <div className="bg-white p-4 rounded-xl shadow-md mt-6">
        <div className="flex items-center mb-4">
          <FontAwesomeIcon icon={faCalendarWeek} className="text-blue-600 text-lg mr-2" />
          <h3 className="text-lg font-bold text-gray-800">Tunggakan Aktif Mingguan</h3>
        </div>
        <div className="bg-green-50 border border-green-200 p-4 rounded-lg">
          <h4 className="text-green-700 font-semibold text-base">Aktif</h4>
          <p className="text-xl font-bold mt-1 text-gray-800">
            RM {weeklyArrears.toFixed(2)}
          </p>
        </div>
      </div>

      {/* Monthly Report */}
      <div className="bg-white p-4 rounded-xl shadow-md mt-6 mb-6">
        <div className="flex items-center mb-4">
          <FontAwesomeIcon icon={faCalendarAlt} className="text-purple-600 text-lg mr-2" />
          <h3 className="text-lg font-bold text-gray-800">Tunggakan Aktif Bulanan </h3>
        </div>
        <div className="bg-green-50 border border-green-200 p-4 rounded-lg">
          <h4 className="text-green-700 font-semibold text-base">Aktif</h4>
          <p className="text-xl font-bold mt-1 text-gray-800">
            RM {monthlyArrears.toFixed(2)}
          </p>
        </div>
      </div>
        <div className="flex justify-center m-5">
          <Link to="/arrears-actives">
           <button className="py-2 px-3 rounded-lg bg-green-500 text-white">
           Lihat Jadual
           </button>
          </Link>
        </div>
    </div>
  );
};

export default SewaArrears;
